import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { ForgotPasswordFormData, FormErrors } from '../types';

interface ForgotPasswordFormProps {
  onSubmit: (data: ForgotPasswordFormData) => Promise<void>;
  onBack: () => void;
  isLoading: boolean;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onSubmit, onBack, isLoading }) => {
  const [formData, setFormData] = useState<ForgotPasswordFormData>({
    email: '',
  });
  const [errors, setErrors] = useState<FormErrors>({});

  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Emailul este obligatoriu';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Introdu o adresă de email validă';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      await onSubmit(formData);
    }
  };

  const handleInputChange = (value: string) => {
    setFormData({ email: value });
    if (errors.email) {
      setErrors({});
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-3">
          <Icon name="KeyRound" size={24} className="text-primary" />
        </div>
        <h2 className="text-2xl font-semibold text-foreground mb-2">Resetare parolă</h2>
        <p className="text-sm text-muted-foreground">
          Introdu adresa de email și îți vom trimite instrucțiuni pentru resetarea parolei.
        </p>
      </div>

      <Input
        type="email"
        label="Adresă de email"
        placeholder="Introdu email-ul"
        value={formData.email}
        onChange={(e) => handleInputChange(e.target.value)}
        error={errors.email}
        required
        disabled={isLoading}
        className="w-full"
      />

      <div className="space-y-3">
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          loading={isLoading}
          iconName="Send"
          iconPosition="right"
        >
          Trimite link de resetare
        </Button>

        <Button
          type="button"
          variant="ghost"
          size="lg"
          fullWidth
          onClick={onBack}
          disabled={isLoading}
          iconName="ArrowLeft"
          iconPosition="left"
        >
          Înapoi la autentificare
        </Button>
      </div>

      <div className="mt-6 p-4 bg-muted rounded-md">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            Dacă nu primești un email în câteva minute, verifică folderul Spam sau contactează suportul.
          </p>
        </div>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
